import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { map, Subject, takeUntil } from 'rxjs';

import { MedicalReportervice, PrescriptionService } from 'app-service';
import { DialogService } from 'app-shared-ui';
import {
  CitiesList,
  Gender,
  MedicalDegree,
  State,
  Util,
} from '@alpha/types';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-appointment-reports',
  templateUrl: './appointment-reports.component.html',
  styleUrls: ['./appointment-reports.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [DialogService, MedicalReportervice, PrescriptionService],
})
export class AppointmentReportsComponent implements OnInit, OnDestroy {
  public reportItem: any = null;
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  public environment = environment;

  public constructor(
    private readonly _cdRef: ChangeDetectorRef,
    private readonly _reportService: MedicalReportervice,
    private readonly _route: Router,
  ) {}

  public ngOnInit(): void {
    if (this._route.url.split('/')[2] === 'view') {
      this.getReports(this._route.url.split('/')[6].split('?')[0]);
    }
  }

  private getReports(appointmentId: string): void {
    this._reportService
      .getMedicalReport(appointmentId)
      .pipe(
        map((appointment: any) => {
          let responseObj: any = {
            _id: '',
            dateIssued: '',
            diagnosis: '',
            followUpDate: '',
            notes: '',
            doctorName: '',
            degree: '',
            address: '',
            registration: '',
            patientName: '',
            date: '',
            clinicName: '',
          };
          responseObj.doctorName = `${appointment!.doctorId!.userId?.firstName} ${appointment!.doctorId!.userId?.lastName}`;
          responseObj.patientName = `${appointment!.userId!.firstName} ${appointment!.userId!.lastName}`;
          responseObj.date = appointment!.date;
          appointment!.doctorId!.qualification!.degree.forEach(
            (degree: number, index: number) =>
              (responseObj.degree +=
                MedicalDegree[degree].toString() +
                (appointment!.doctorId!.qualification!.degree.length - 1 > index
                  ? ', '
                  : '')),
          );
          if (
            appointment!.doctorId!.clinic &&
            appointment!.doctorId!.clinic[0]
          ) {
            responseObj.clinicName = `${appointment!.doctorId!.clinic[0]!.name}`;
            responseObj.address = `${appointment!.doctorId!.clinic[0]!.location.block ? appointment!.doctorId!.clinic[0]!.location.block + ',' : ''} 
                                   ${appointment!.doctorId!.clinic[0]!.location.street ? appointment!.doctorId!.clinic[0]!.location.street + ',' : ''}
                                   ${appointment!.doctorId!.clinic[0]!.location.city ? appointment!.doctorId!.clinic[0]!.location.city + ',' : ''}
                                   ${appointment!.doctorId!.clinic[0]!.location.subDistrict ? CitiesList[appointment!.doctorId!.clinic[0]!.location.subDistrict] + ',' : ''}
                                   ${appointment!.doctorId!.clinic[0]!.location.district ? CitiesList[appointment!.doctorId!.clinic[0]!.location.district] + ',' : ''}
                                   ${appointment!.doctorId!.clinic[0]!.location.state ? State[appointment!.doctorId!.clinic[0]!.location.state] + ',' : ''}
                                   Pin - ${appointment!.doctorId!.clinic[0]!.location.zip}`;
          }
          responseObj.registration =
            appointment?.doctorId?.qualification?.registrationNumber;
          responseObj.followUpDate = appointment?.followUpDate;
          responseObj.notes = appointment?.report?.notes;
          responseObj.report = [appointment?.report];
          if (appointment!.userId!.birthday) {
            responseObj.patientAge = Util.calculateAge(
              new Date(appointment!.userId!.birthday),
            );
          }
          if (appointment!.userId!.gender !== undefined) {
            responseObj.patientGender = Gender[appointment!.userId!.gender];
          }
          if (appointment!.userId!.weight !== undefined) {
            responseObj.patientWeight = appointment!.userId!.weight;
          }
          responseObj.title = appointment?.report?.title;
          responseObj.summary = appointment?.report?.summary;
          responseObj.published = appointment?.report?.published;
          responseObj.impression = appointment?.report?.impression;
          responseObj.adv = appointment?.report?.adv;

          return responseObj;
        }),
        takeUntil(this.ngUnsubscribe),
      )
      .subscribe((res: any) => {
        this.reportItem = res;
        this._cdRef.markForCheck();
      });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
